import React from "react";
import { ApolloProvider } from "@apollo/client";
import { client } from "helpers/apolloClientLink";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { fetch as backendRouter } from "helpers/router";
import ErrorPage from "components/ErrorPage";
import LoginForm from "./components/LoginForm";
import SignupForm from "./components/SignupForm";
import PasswordResetForm from "./components/PasswordResetForm";
import { TurnstileProvider } from "../../components/TurnstileProvider";

const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        path: backendRouter("auth"),
        element: <LoginForm />,
      },
      {
        path: backendRouter("signup"),
        element: <SignupForm />,
      },
      {
        path: backendRouter("auth.password.reset.index"),
        element: <PasswordResetForm />,
      },
    ],
  },
]);

const Auth = () => (
  <ApolloProvider client={client}>
    <div className="col-sm-6 col-sm-offset-3 login">
      <div className="content">
        <TurnstileProvider>
          <RouterProvider router={router} />
        </TurnstileProvider>
      </div>
    </div>
  </ApolloProvider>
);

export default Auth;
